import React from "react";
import Layout from "../../../components/layout";
import ApmNavbar from "../../../components/navbar-apm";
import { Link } from "gatsby";

const Page = () => (
  <Layout title="APM Pricing" hasSubNav={true}>
    <ApmNavbar selection="pricing" />

    <section className="section apm-pricing-desc-section">
      <div className="container">
        <div className="pricing-description">
          <h1>DripStat APM Pricing</h1>
          <h4>
            Choose between <strong>Annual License</strong> or <strong>Pay as you Go License</strong>.
          </h4>
          <h4>
            If you use the cloud, <strong>Pay as you Go</strong> is the best option, since you are billed hourly, just
            <br /> like the rest of your cloud instances.
          </h4>
        </div>

        <div className="pricing-description">
          <h2>DripStat Puppy</h2>
        </div>

        <table className="pricing-table">
          <tr>
            <th className="text-left">Instance Size</th>
            <th>Annual</th>
            <th>Pay as you Go</th>
          </tr>
          <tr>
            <td>Any Size</td>
            <td>$30/month</td>
            <td>$0.05 per hour (~$35/month)</td>
          </tr>
        </table>

        <div className="pricing-description">
          <h2>DripStat Pro</h2>
          <h4>Pay based on the size of your instance. The smaller the instance, the less you pay.</h4>
        </div>

        <table className="pricing-table">
          <tr>
            <th className="text-left">Instance Size</th>
            <th>Annual</th>
            <th>Pay as you Go</th>
          </tr>
          <tr>
            <td>
              <span>Small</span> (&lt;= 5GB RAM)
            </td>
            <td>$30/month</td>
            <td>$0.06 per hour (~$40/month)</td>
          </tr>
          <tr>
            <td>
              <span>Medium</span> (&lt;= 10GB RAM)
            </td>
            <td>$60/month</td>
            <td>$0.11 per hour (~$80/month)</td>
          </tr>
          <tr>
            <td>
              <span>Large</span> (&gt; 10GB RAM)
            </td>
            <td>$100/month</td>
            <td>$0.17 per hour (~$120/month)</td>
          </tr>
        </table>
      </div>
    </section>
    <section className="section apm-pricing-section">
      <div className="container">
        <div className="columns">
          <div className="column lite-block apm-pricing-block is-one-quarter">
            <div className="header">
              <h2>Free</h2>
              <h4>
                <strong>1 Hour</strong> data retention
              </h4>
              <h4>
                <strong>Free</strong> forever
              </h4>
            </div>
            <div className="body">
              <ul>
                <li>Application Stats</li>
                <li>Transactions</li>
                <li>Alerts (Limited)</li>
              </ul>
            </div>
          </div>

          <div className="column puppy-block apm-pricing-block">
            <div className="header">
              <h2>Puppy</h2>
              <h4>
                <strong>90 Day</strong> data retention
              </h4>
              <h4>
                <strong>Unlimited JVMs</strong> per Host
              </h4>
              <h4>
                <strong>Unlimited Containers</strong> per Host
              </h4>
            </div>
            <div className="body">
              <h4>Everything in Free and:</h4>
              <ul>
                <li>Transaction Traces</li>
                <li>Detailed JVM Stats</li>
                <li>Slow SQL Queries</li>
                <li>Database Calls</li>
                <li>AWS Calls</li>
                <li>External Service Calls</li>
                <li>Alerts (Full featured)</li>
              </ul>
            </div>
          </div>
          <div className="column pro-block apm-pricing-block">
            <div className="header">
              <h2>Pro</h2>
              <h4>
                <strong>90 Day</strong> data retention
              </h4>
              <h4>
                <strong>Unlimited JVMs</strong> per Host
              </h4>
              <h4>
                <strong>Unlimited Containers</strong> per Host
              </h4>
            </div>
            <div className="body">
              <h4>Everything in Puppy and:</h4>
              <ul>
                <li>Detailed Transaction Segments</li>
                <li>Stacktraces</li>
                <li>Exception Tracking</li>
                <li>JVM Profiler</li>
                <li>Slow SQL Queries</li>
                <li>Dynamically Generated Reports</li>
                <li>Deployment Tracking</li>
                <li>Scalability Analysis</li>
                <li>Per App Database, AWS, External Service calls</li>
                <li>Dynamic Slice n Dice of Data</li>
              </ul>
              <h4>And much, much more...</h4>
            </div>
          </div>
        </div>

        <div className="columns">
          <div className="column has-text-centered">
            <Link
              className="button is-primary is-large"
              to="/signup"
              style={{ backgroundColor: "#FFD94A", color: "black", marginTop: "5rem", marginBottom: "4rem", fontSize: "1.25rem", fontWeight: "bold", padding: "1.8rem 4.5rem" }}
            >
              Sign Up
            </Link>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

export default Page;
